import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, Grid } from "@material-ui/core";
import MuiTabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { PendingButton } from "@ploy-ui/core";
import { Panel } from "../../panel";
import { makeStyles } from "@material-ui/core/styles";
import { usePageState } from "../../PageContext";
import { addRegisteredLayout } from "./layoutDescriptions";
const useStyles = makeStyles((theme) => ({
    mainSections: {
        padding: theme.spacing(10),
        paddingTop: 0
    },
    sidebar: {
        padding: theme.spacing(4)
    }
}));
addRegisteredLayout({
    name: "Tabs",
    displayName: "Tabs",
    panels: { main: {}, summaryHeader: {}, summary: {} }
});
export function Tabs(props) {
    const classes = useStyles(props);
    const { header, panels } = props;
    const { step, goto, labels } = usePageState();
    const main = panels.main;
    const summary = panels.summary;
    const summaryHeader = panels.summaryHeader;
    return (_jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, xs: 12, container: true, spacing: 3, children: _jsx(Grid, { item: true, xs: 4, children: header }) }), _jsx(Grid, { item: true, md: 8, container: true, spacing: 3, direction: "column", children: _jsx(Grid, { item: true, children: _jsxs(Paper, { children: [_jsx(MuiTabs, { value: step, onChange: (e, value) => goto(value), indicatorColor: "primary", textColor: "primary", variant: "fullWidth", children: labels.map((label, i) => (_jsx(Tab, { label: label || i }, label || i))) }), main && _jsx(Panel, { className: classes.mainSections, ...main })] }) }) }), (summaryHeader || summary) && (_jsxs(Grid, { item: true, md: 4, container: true, spacing: 3, direction: "column", children: [summaryHeader && (_jsx(Grid, { item: true, children: _jsx(Panel, { className: classes.sidebar, elevation: 2, ...summaryHeader }) })), _jsx(Grid, { item: true, children: _jsx(PendingButton, { variant: "contained", color: "secondary", 
                            // type="submit"
                            // pending={Boolean(form.asyncValidating) || form.submitting}
                            fullWidth: true, children: "Ny s\u00F8knad" }) }), summary && (_jsx(Grid, { item: true, children: _jsx(Panel, { className: classes.sidebar, elevation: 2, ...summary }) }))] }))] }));
}
//# sourceMappingURL=Tabs.js.map